export default __webpack_public_path__ + "static/sea-7d38d0358db0e065643c3984666a524c.png";